import { render, staticRenderFns } from "./index.vue?vue&type=template&id=e2328042&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=e2328042&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2328042",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CardItem: require('C:\\Users\\Jahseh.J.Zhou\\Desktop\\项目\\b5web-ssr\\components\\b5News\\CardItem.vue').default})
